<template>
<div class="modal is-large" :class="{ 'is-active': active }">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <div class="default-settings-title">
                <span class="account-name">Replicate snapshots to multiple regions</span>
                <span class="default-settings-subtitle">Configure in which regions the snapshots of the cloudlet should be replicated. For DigitalOcean, it doesn't cost more to replicate a snapshot to more regions.</span>
            </div>

            <div v-if="loading" class="columns m-top-15">
                <div class="column is-full has-text-centered">
                    <img src="/loader-dark.svg">
                </div>
            </div>
            <div v-if="!loading" class="columns is-multiline m-top-15">
                <div @click="toggleRegionSelection(region)" class="column is-3" v-for="region in regions.data">
                    <div class="region" :class="{ 'region-selected': regionIsSelected(region), 'region-disabled': !region.snapshot_replication, 'cursor-pointer': region.snapshot_replication }">
                        <div class="region-flag">
                            <img :src="require('@/assets/img/regions/' + region.slug + '.svg')">
                        </div>
                        <div class="region-name">
                            {{ region.slug }}
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!loading" class="columns is-multiline m-top-20">
                <div class="column is-3">
                    <div @click="updateReplicationRegions" :class="{ 'is-loading': updatingReplicationRegions }" :disabled="updatingReplicationRegions" class="button custom-button-size is-fullwidth is-info">Save</div>
                </div>
                <div class="column is-3">
                    <div @click="close" :disabled="updatingReplicationRegions" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger">Cancel</div>
                </div>
            </div>

        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
import Api from '@/api';

export default {
    props: ['cloudletId'],

    data() {
        return {
            snapshot: null,
            regions: [],
            selectedRegions: [],
            loadingRegions: true,
            loadingCloudletReplicationRegions: true,
            updatingReplicationRegions: false,
            active: false,
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        getRegions() {
            let endpoint = 'regions';

            Api().get(endpoint)
                .then((response) => {
                    this.regions = response.data;
                })
                .catch((error) => {
                    //
                })
                .finally(() => {
                    this.loadingRegions = false;
                });
        },

        getCloudletReplicationRegions() {
            let endpoint = 'cloudlets/' + this.cloudletId + '/replication-regions';

            Api().get(endpoint)
                .then((response) => {
                    for (var i = 0; i < response.data.data.length; i++) {
                        this.selectRegion(response.data.data[i]);
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    this.loadingCloudletReplicationRegions = false;
                });
        },

        updateReplicationRegions() {
            if (this.updatingReplicationRegions) {
                return;
            }

            this.updatingReplicationRegions = true;
            let endpoint = 'cloudlets/' + this.cloudletId + '/replication-regions';

            Api().put(endpoint, {replication_regions: this.selectedRegions})
                .then((response) => {
                    this.updatingReplicationRegions = false;
                    this.close();
                    swal('Success!', 'The cloudlet replication regions updated successfully.', 'success');
                })
                .finally(() => {
                    this.updatingReplicationRegions = false;
                });
        },

        show() {
            this.active = true;
            this.getRegions();
            this.getCloudletReplicationRegions();
        },

        close() {
            if (this.updatingReplicationRegions) {
                return;
            }

            this.active = false;
            this.reset();
        },

        reset() {
            this.replications = [];
            this.loadingReplications = true;
            this.loadingCloudletReplicationRegions = true;
            this.selectedRegions = [];
        },

        regionIsSelected(region) {
            return this.selectedRegions.indexOf(region.id) != -1;
        },

        toggleRegionSelection(region) {
            if (this.regionIsSelected(region)) {
                this.unselectRegion(region);
            } else {
                this.selectRegion(region);
            }
        },

        selectRegion(region) {
            this.selectedRegions.push(region.id);
        },

        unselectRegion(region) {
            var index = this.selectedRegions.indexOf(region.id);
            if (index != -1) {
                this.selectedRegions.splice(index, 1);
            }
        },

        listenEvents() {
            Event.$on('showReplicationRegions', (cloudletId) => {
                this.show();
            });
        },
    },

    computed: {
        loading() {
            return this.loadingRegions || this.loadingCloudletReplicationRegions;
        },
    },

    watch: {
        cloudletId(cloudletId) {
            this.getRegions();
            this.getCloudletReplicationRegions();
        },
    },
}
</script>
